function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavBilling = function SvgNavBilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M196.45,37.82c-2.59-3.06-6.22-4.93-10.22-5.27L45.38,20.8c-4-.33-7.89.91-10.95,3.5-3.05,2.58-4.92,6.19-5.26,10.17l-2.83,26.58h-11.31C6.74,61.05,0,67.79,0,76.07v88.16C0,172.52,6.74,179.26,15.02,179.26h141.33c8.28,0,15.02-6.74,15.02-15.02v-14.3l5.02.42c.42.03.84.05,1.26.05,7.72,0,14.3-5.94,14.96-13.77l7.34-87.86c.33-4-.91-7.89-3.5-10.95ZM163.56,164.24c0,3.98-3.23,7.21-7.21,7.21H15.02c-3.98,0-7.21-3.23-7.21-7.21v-48.3h155.75v48.3ZM163.56,108.12H7.81v-16.21h155.75v16.21ZM163.56,84.11H7.81v-8.03c0-3.98,3.23-7.21,7.21-7.21h141.33c3.98,0,7.21,3.23,7.21,7.21v8.03ZM184.83,135.98c-.33,3.96-3.82,6.92-7.78,6.58l-5.67-.47v-66.02c0-8.28-6.74-15.02-15.02-15.02H34.19l2.75-25.8s0-.06,0-.09c.33-3.96,3.82-6.92,7.78-6.58l140.84,11.76c1.92.16,3.66,1.06,4.9,2.53,1.24,1.47,1.84,3.34,1.68,5.26l-7.34,87.86Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.71,
    y: 127.55,
    width: 45.41,
    height: 32.34,
    rx: 3.91,
    ry: 3.91,
    style: {
      fill: "#e3f9ff",
      strokeWidth: 0
    }
  }));
};
export default SvgNavBilling;